import { IApplicationState } from '../../../../../../types/types';

export const getRecentNotification = (
    state: IApplicationState
): number => {
    return state.notifications.recentNotification;
};
